import { render, staticRenderFns } from "./RegulatedPropertiesV2.vue?vue&type=template&id=681aff20&"
import script from "./RegulatedPropertiesV2.vue?vue&type=script&lang=js&"
export * from "./RegulatedPropertiesV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports